// ----------------------------------------------------------------------------
// Snippet: PDP Tabs
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_pdp-tabs.scss';

// Variables
const SPECS_CONTENT_WRAPPER = '.specs-tab-content';
const PRODUCT_FORM_WRAPPER = '[data-product-form]';

// Functions
document.addEventListener('DOMContentLoaded', () => {
    // Select the product form
    const productForm = document.querySelector(PRODUCT_FORM_WRAPPER);

    // Select all the specs content wrappers
    const specsContentWrappers = document.querySelectorAll(SPECS_CONTENT_WRAPPER);
    
    if (!productForm || !specsContentWrappers) {
        return;
    }

    // Function to update table visibility based on current variant ID
    const updateTableVisibility = () => {
        const currentVariantId = productForm?.dataset.currentVariantId;

        specsContentWrappers?.forEach(specsContent => {
            const tableVariantId = specsContent.dataset.specsVariantId;

            if (tableVariantId === currentVariantId) {
                specsContent.classList.remove('hidden');
                specsContent.classList.add('visible');
            } else {
                specsContent.classList.remove('visible');
                specsContent.classList.add('hidden');
            }
        });
    };

    // Initial update
    updateTableVisibility();

    // Create a MutationObserver to watch for changes to data-current-variant-id
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === 'data-current-variant-id') {
                updateTableVisibility();
            }
        });
    });

    // Configure the observer to watch for attribute changes
    observer.observe(productForm, {
        attributes: true,
        attributeFilter: ['data-current-variant-id']
    });
});